import { useCallback } from 'react';
import { useIsMobile } from '../../../../../utils/getIsMobile';
import { CircularProgress } from '../../../../feedback/CircularProgress';
import { Box } from '../../../../layout/Box';
import { DataTestId } from '../../../../layout/DataTestIdWrapper';
import { MediaCover } from '../../../../media/MediaCover';
import { MediaPreview } from '../../../MediaPreview';
import { getLinkProps } from '../../../utils/getLinkProps';
import { CardMediaProps } from './types';

export const CardMedia: React.FC<CardMediaProps> = ({
    media,
    index,
    ratio,
    containerRef,
    spinnerEnabled,
    mediaCoverEnabled,
    imageAlias,
    href,
    isExternalHref,
    alt,
    onClick,
    handleMouseOn,
    handleMouseOff,
}) => {
    const isMobile = useIsMobile();

    const handleClick = useCallback(
        (event: React.MouseEvent) => {
            // иначе к переходу из onClick добавится ещё и переход по ссылке
            if (href) {
                event.preventDefault();
            }

            onClick?.();
        },
        [href, onClick],
    );

    return (
        <MediaCover
            {...getLinkProps(href, { external: isExternalHref })}
            width="100%"
            height="100%"
            ratio={ratio}
            onClick={handleClick}
            cursor="pointer"
            borderRadius={2}
            onMouseEnter={isMobile ? undefined : handleMouseOn}
            onMouseLeave={isMobile ? undefined : handleMouseOff}
            dataTestId={DataTestId.POST_CARD_GRID_MEDIA_COVER}
        >
            <Box ref={containerRef} />

            {mediaCoverEnabled || media.type !== 'video' ? (
                <MediaPreview
                    lazyLoad={index > 0}
                    media={media}
                    imageAlias={imageAlias}
                    alt={alt}
                />
            ) : null}

            {spinnerEnabled ? (
                <Box
                    position="absolute"
                    top="50%"
                    left="50%"
                    zIndex={10}
                    transform="translate(-50%, -50%)"
                    height="fit-content !important"
                    width="fit-content !important"
                >
                    <CircularProgress size={26} color="#FFFFFF" />
                </Box>
            ) : null}
        </MediaCover>
    );
};
